var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcWeightGray(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_1599_137)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.9998 7C12.2832 7 12.5208 6.90433 12.7128 6.713C12.9042 6.521 12.9998 6.28333 12.9998 6C12.9998 5.71667 12.9042 5.479 12.7128 5.287C12.5208 5.09567 12.2832 5 11.9998 5C11.7165 5 11.4792 5.09567 11.2878 5.287C11.0958 5.479 10.9998 5.71667 10.9998 6C10.9998 6.28333 11.0958 6.521 11.2878 6.713C11.4792 6.90433 11.7165 7 11.9998 7ZM14.8248 7H16.5748C17.0748 7 17.5082 7.16667 17.8748 7.5C18.2415 7.83333 18.4665 8.24167 18.5498 8.725L19.9748 18.725C20.0582 19.325 19.9042 19.854 19.5128 20.312C19.1208 20.7707 18.6165 21 17.9998 21H5.99984C5.38318 21 4.87918 20.7707 4.48784 20.312C4.09584 19.854 3.94151 19.325 4.02484 18.725L5.44984 8.725C5.53318 8.24167 5.75818 7.83333 6.12484 7.5C6.49151 7.16667 6.92484 7 7.42484 7H9.17484C9.12484 6.83333 9.08318 6.67067 9.04984 6.512C9.01651 6.354 8.99984 6.18333 8.99984 6C8.99984 5.16667 9.29151 4.45833 9.87484 3.875C10.4582 3.29167 11.1665 3 11.9998 3C12.8332 3 13.5415 3.29167 14.1248 3.875C14.7082 4.45833 14.9998 5.16667 14.9998 6C14.9998 6.18333 14.9832 6.354 14.9498 6.512C14.9165 6.67067 14.8748 6.83333 14.8248 7Z",
    fill: "#26A7DF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_1599_137",
    x: -4,
    y: -4,
    width: 32,
    height: 32,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_1599_137"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_1599_137",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcWeightGray);
export default __webpack_public_path__ + "static/media/ic_weight_gray.f6d33df01595e0ee3f2587c68709d234.svg";
export { ForwardRef as ReactComponent };